import { motion } from "framer-motion";
import queryString from "query-string";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { fadeInAndRight } from "../../services/shared/animation.service";
import {
  capitalizeFirstLetter,
  setEcommerceURL,
} from "../../services/shared/utils.service";
import { useAuthStore } from "../../store";

import introIllustration from "../../assets/introIllustration.png";
import loaderpickit from "../../assets/loader-pickit.gif";
import corner from "../../assets/tableCorner.svg";
import { customerName, customerRouteName } from "../../data/InfoSource";
import { configAxiosRequest } from "../../services/axios";
import { signInWoo } from "../../services/onboarding.service";
import { showErrorWoo } from "../../services/shared/alert.service";
import { setToken } from "../../services/storage";

export const Loader = () => {
  const location = useLocation();
  let history = useHistory();
  const addAuth = useAuthStore((state) => state.addAuthData);
  const user = useAuthStore((state) => state.authData.user);

  const ecommerce = setEcommerceURL(location);

  const { accessToken = "" } = queryString.parse(location.search);

  const flowLogin = async () => {
    if (user?.insidePanel) {
      addAuth({
        user: {
          ...user,
          insidePanel: false,
        },
      });
    }
    document.title = `${capitalizeFirstLetter(
      customerName
    )} - ${capitalizeFirstLetter(ecommerce)}`;

    if (accessToken) {
      try {
        const records = await signInWoo(accessToken);
        const { token, store, type, isPostPay, typePyment } = records;
        setToken(token);
        configAxiosRequest({ accessToken: token });
        addAuth({
          user: {
            ...user,
            accessToken: token,
            typeToken: type,
            store,
            isPostPay,
            typeOfMerchant: typePyment,
          },
        });
        history.push(`/${customerRouteName}/woo/panel/order/all`);
      } catch (error) {
        addAuth({
          user: {
            accessToken: "",
          },
        });
        showErrorWoo("Error en credenciales", error);
      }
    } else {
      addAuth({
        user: {
          accessToken: "",
        },
      });
      showErrorWoo("Error en credenciales", "Token no válido");
    }
  };

  useEffect(() => {
    flowLogin();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  return (
    <div className="container-fluid" id="welcome">
      {accessToken ? (
        <>
          <div className="corner-background">
            <img src={corner} alt="" />
          </div>
          <div className="row">
            <div className="col col-12 form-col">
              <motion.div
                className="form-wrapper"
                variants={fadeInAndRight}
                initial="hidden"
                animate="visible"
              >
                <h2 className="fw-bold">Iniciando sesión.</h2>
                <p>Por favor espere...</p>
                <img
                  className="loader-woo-img"
                  src={introIllustration}
                  alt=""
                />
                <img className="loader-woo-gif" src={loaderpickit} alt="" />
              </motion.div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
